import { Link } from '@/i18n/navigation';

const NextLink = ({ children, href, ...props }) => {
  return (
    <Link href={href || ''} prefetch={false} {...props}>
      {children}
    </Link>
  );
};

export default NextLink;
